module.exports = __webpack_public_path__ + "static/media/IsometricPullFemale.dcb09b74.svg";